import { Formik, useField, Form } from 'formik'
import React, { useContext, useRef, useLayoutEffect } from 'react'
import AppNavigation from '../../AppNavigation'
import { AppContext } from '../../../App'
import axios from 'axios'
import * as Yup from 'yup'
import config from '../../../config.json'

export default function AdhesivesCoverageDetails() {
   const {
      setAppHeader,
      setCurrentStep,
      stepsCompleted,
      setStepsCompleted,
      setCoverageDetails,
      unit,
      setUnit,
      productCoverage,
       setCoverageData,
       productSelected,
      coverageData
    } = useContext(AppContext)

    console.log(productSelected)
   
   //Create custom form elements
   const CustomInputTotalArea = ({ label, ...props }) => {
      const [field, meta] = useField(props)
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-8">
                  <div className="row p-1">
                     <div className="col-xs-12 col-sm-6">
                           <label htmlFor={props.id || props.name}>{label}</label>
                     </div>
                     <div className="col-xs-12 col-sm-6">
                           <input className="text-input" {...field} {...props} />
                           { meta.touched && meta.error ? (
                              <div className="error">{ meta.error }</div>
                           ) : null }
                     </div>
                  </div>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <label className="unit-label">
                     ft&#178;
                     <input type="radio" name="radio-unit" checked={unit==="sqft"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqft" value="sqft" />
                  </label>
                  <label className="unit-label">
                     m&#178;
                     <input type="radio" name="radio-unit" checked={unit==="mm"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqm" value="mm" />
                  </label>
               </div>
         </div>
      )
   }
   const CustomSelect = ({ label, modalFor, ...props }) => {
      const [field, meta] = useField(props, 'checkbox')
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-4">
                  <label htmlFor={props.id || props.name}>{label}</label>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <select {...field} {...props} id={props.name} />
                  { meta.touched && meta.error ? (
                     <div className="error">{ meta.error }</div>
                  ) : null }
               </div>
         </div>
      )
   }



   const firstUpdate = useRef(true)

   useLayoutEffect(() => {
      if (firstUpdate.current) {
         firstUpdate.current = false
         return
      }
      
      // Update the current step.
      setCurrentStep({ step: "adhesivesQuoteCreated" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Provide Coverage Details")
      setStepsCompleted(stepsCompleted)
      // Set the appHeader for Step state.
      setAppHeader("Quote created.")
   }, [coverageData])

    const adhesiveCalculation = (trowelCoverage, totalArea) => {
        let thicknessCoverageText, trowelCoverageCoverage
        const apiUrlRoot = config.adhesivesEndpoint

        if (!trowelCoverage) {
            trowelCoverageCoverage = productCoverage;
        } else {
            [thicknessCoverageText, trowelCoverageCoverage] = trowelCoverage.split('|');
        }

        let url = `${apiUrlRoot}/GetAdhesiveResult/${unit}/${totalArea}/${trowelCoverageCoverage}`

      axios.get(url)
      .then(res => {
          setCoverageData({ coverage: trowelCoverageCoverage, quantity: res.data.quantity, unitsRequiredDefault: res.data.unitsRequiredDefault, actualUnitsRequiredDefault: res.data.actualUnitsRequiredDefault, trowelCoverageText: thicknessCoverageText })
      })
      .catch(err => {
         console.log(err)
      })
   }

   const handleFormSubmission = (formData) => {
      const { trowelSize, totalArea } = formData
      // Add the input data to state of App.
      setCoverageDetails({ formData })

      // Calculate adhesive amount required.
      adhesiveCalculation(trowelSize, totalArea)
   }

   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3 adhesives-body">
               <h3>Provide Coverage Details</h3>
               <Formik
                  initialValues={{
                     totalArea: '',
                     unit: 'sqft',
                     trowelSize: ''
                  }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validationSchema={Yup.object().shape({
                     totalArea: Yup.number()
                           .required('This field is required.')
                           .positive('This value must be positive.'),
                     unit: Yup.string()
                           .required('Select unit')
                  })}
                  onSubmit={ (values) => {
                     handleFormSubmission(values)
                  } }
                  >
                  {
                  props => (
                     <Form>
                           <CustomInputTotalArea label="Total Area" name="totalArea" type="number" placeholder="Enter total area" />
                           
                                 <CustomSelect label="Trowel Size (WxH)" name="trowelSize">
                                      <option value=""></option>
                              {
                                  JSON.parse(productSelected.trowelCoverage).map((t, index) => {
                                      return (
                                          unit === "sqft" ? (
                                              <option key={t.ThicknessTextInches} value={`${t.ThicknessTextInches}|${t.Coverage}`}>{t.ThicknessTextInches}</option>
                                          ) : <option key={t.ThicknessTextMetric} value={`${t.ThicknessTextMetric}|${t.Coverage}`}>{t.ThicknessTextMetric}</option>
                                      )
                                  })
                              }
                                 </CustomSelect>
                              
                           <button className="btn btn-primary" type="submit">{ props.isSubmitting ? 'Loading...' : 'Submit' }</button>
                     </Form>
                     )}
               </Formik>
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/adhesives/AdhesivesCoverageDetails.js